<template>
  <article id="article-home">
    <!-- Main Article -->
    <section id="section-main-article">
      <img id="header-background" v-lazy="background" />
      <header>
        <div
          v-if="highlight"
          class="post-card"
          data-action="open_post"
          :data-postid="highlight.id"
          data-listname="home_top"
          id="highlight"
          @click="open(highlight.link+'?webview=line&bt_id=71')"
        >
          <div class="image">
            <img class="thumbnail" :src="highlight.post_thumbnail_url" />
          </div>
          <div class="content">
            <div class="title">บทความล่าสุด</div>
            <div class="description" v-html="highlight.title ? highlight.title.rendered : ''"></div>
          </div>
        </div>
      </header>
    </section>

    <!-- Watchlist -->
    <section id="section-watchlist">
      <FollowingList />
    </section>

    <!-- Trending -->
    <section id="section-trending">
      <trending></trending>
    </section>

    <!-- Other Article -->
    <section id="section-other-article">
      <OtherArticle :isHighlightArticle="isHighlightArticle" />
    </section>

    <i v-if="isScrollTop" @click="goTop" class="fas fa-chevron-up scrollTop"></i>
  </article>
</template>

<script>
const FollowingList = () => import("../../components/miniapp/home/FollowingList")
const OtherArticle = () => import("../../components/miniapp/home/OtherArticle")
const Trending = () => import("../../components/miniapp/home/Trending")
import { getPostByTagsId } from "../../../store/api/article.js"
import { mapGetters, mapActions } from "vuex"
import axios from "axios"

export default {
  components: {
    FollowingList,
    OtherArticle,
    Trending
  },
  data() {
    return {
      background: {
        src: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background/home-header@3x.png`,
        error: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background/home-header.png`,
        loading: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background/home-header.png`
      },
      highlight: {},
      currentScroll: 0,
      isScrollTop: false,
      isHighlightArticle: true,
    }
  },
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        let path = `${process.env.VUE_APP_SCONTENT_URL}/line-liff/background`
        let fileName = `home-header@3x.png`
        if (this.getUserSetting && this.getUserSetting.theme === "dark") {
          this.background.src = `${path}/dark/${fileName}`
          this.background.error = `${path}/dark/${fileName}`
          this.background.loading = `${path}/dark/${fileName}`
        }
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["getIslogin", "getUser"]),
    ...mapGetters("onboarding", ["getUserSetting"]),
  },
  created() {
    window.addEventListener("scroll", this.handleScroll)
  },
  mounted: async function() {
    await this.getLatestArticle()
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    ...mapActions("article", ["findArticleByParams"]),
    getHighlight: async function() {
      const { data: config } = await axios.get("/config/home-config.json")
      let { data: highlight } = await getPostByTagsId(config.highlight_article_tag)
      if (highlight && Array.isArray(highlight)) {
        this.highlight = highlight[0]
      }
    },
    async getLatestArticle() {
        this.isHighlightArticle = false
        const latestArticle = await this.findArticleByParams({per_page: 1})
        if (latestArticle && Array.isArray(latestArticle)) this.highlight = latestArticle[0]
    },
    open(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
    handleScroll() {
      this.currentScroll = window.scrollY
      if (this.currentScroll > 4000) this.isScrollTop = true
      else this.isScrollTop = false
    },
    goTop() {
      window.scroll(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
$radius-size: 8px;

#article-home {
  padding-top: 16px;
  position: relative;
   #go-to-setting {
    text-align: right;
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      @include finCol(12, 12, 16px, middle, true, true);
    }
    #setting-btn {
      color: $base-white;
      position: relative;
      margin: 0;
      display: inline-block;
      text-decoration: none;
      @extend %font-size-ss;
      font-weight: bold;
      border-radius: 15px;
      border: solid 1px #ffffff;
      padding: 0px 6px;

      i {
        margin-right: 4px;
      }

      .spacer {
        display: inline-block;
        width: 20px;
      }

      .img-profile-group {
        width: 18px;
        height: 18px;
        display: inline-block;
        margin: auto;
        overflow: hidden;
        vertical-align: middle;
        border-radius: 50%;
        border: 1px solid $color-white;
        position: absolute;
        top: calc(50% - 9px);
        left: 3px;
        .img-profile {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  #section-main-article {
    padding-top: 16px;
    padding-bottom: 24px;
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      max-width: $max-width-tablet;
    }
    #header-background {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      @include responsive(mobile) {
        max-height: 186px;
      }
      @include responsive(phablet) {
        max-height: 240px;
      }
      @include responsive(tablet) {
        max-height: 260px;
      }
    }
    header {
      .post-card {
        background: var(--color-surface);
        border-radius: $radius-size;
        -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
        pointer-events: auto;
        .image {
          pointer-events: none;
          @include multipleResponsive(phablet, tablet) {
            @include finCol(8, 12, 16px, middle, true, true);
            border-bottom-left-radius: 8px;
          }
          .thumbnail {
            pointer-events: none;
            object-fit: cover;
            border-top-left-radius: $radius-size;
            border-top-right-radius: $radius-size;
            display: block;
            width: 100%;
            @include multipleResponsive(phablet, tablet) {
              border-bottom-left-radius: 8px;
            }
          }
        }
        .content {
          pointer-events: none;
          @include multipleResponsive(phablet, tablet) {
            @include finCol(4, 12, 16px, middle, true, true);
            padding: 0 16px;
          }
          padding: 16px;
          margin: 0px;
          display: inline-block;
          .title {
            @extend %font-size-m;
            color: var(--color-header-text);
            font-weight: bold;
          }
          .description {
            @extend %font-size-ss;
            color: var(--color-header-text);
          }
        }
      }
    }
  }
  #section-trending {
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      max-width: $max-width-tablet;
    }
  }
  #section-watchlist,
  #section-other-article {
    padding-bottom: 24px;
    @extend %container-style;
    @include multipleResponsive(phablet, tablet) {
      max-width: $max-width-tablet;
    }
  }

  .scrollTop {
    // display: none;
    position: fixed;
    bottom: 10%;
    right: 10px;
    z-index: 99;
    border: none;
    font-size: 24px;
    outline: none;
    background-color: #f9f9f9;
    color: $color-secondary-text;
    cursor: pointer;
    padding: 15px;
    border-radius: 50%;
  }
}
</style>